import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-2xl px-3 pb-1.5 pt-1 text-sm font-bold transition-colors focus:outline-none',
  {
    variants: {
      variant: {
        error: 'bg-[#fcc7d5] text-[#952e48]',
        neutral: 'bg-[#f3f3ff] text-[#5e619d]',
        outline: 'border border-[rgba(86,83,134,0.17)] bg-white text-[#7c8d9f]',

        // Legacy variants for backwards compatibility
        default:
          'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        success:
          'border-transparent bg-success text-emerald-900 hover:bg-success/80',
        warning:
          'border-transparent bg-warning text-warning-foreground hover:bg-warning/80',
        info: 'border-transparent bg-info text-info-foreground hover:bg-info/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        development:
          'bg-development text-development-foreground hover:bg-development/80',
        staging: 'bg-staging text-staging-foreground hover:bg-staging/80',
        production:
          'bg-production text-production-foreground hover:bg-production/80',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
